import { Row, Col } from "antd";
import { DocumentFileRow } from "@/entities/journal";
import {
  fallbackString,
  formatAdministrativeDocument,
} from "@/shared/utils";
import type { components } from "@entities/journal";
import { Link } from "@shared/lib/react-router";

type Representative = components["schemas"]["Representative"];

interface IRepresentativeWrapper {
  rep?: Representative;
}



export const RepresentativeWrapper = ({
  rep,
}: IRepresentativeWrapper) => {
  if (rep) {
    return (
      <Row gutter={[16, 16]} style={{ marginTop: "16px" }}>
        <>
          <Col span={8} style={{ color: "#888888" }}>
            Номер в НОПРИЗ
          </Col>
          <Col span={16}>
            {fallbackString(rep.user?.specialistNumberEngineering)}
          </Col>
        </>
        <>
          <Col span={8} style={{ color: "#888888" }}>
            Номер в НОСТРОЙ
          </Col>
          <Col span={16}>
            {fallbackString(rep.user?.specialistNumberBuilding)}
          </Col>
        </>
        <>
          <Col span={8} style={{ color: "#888888" }}>
            Телефон
          </Col>
          <Col span={16}>{fallbackString(rep.user?.mobilePhone)}</Col>
        </>
        <>
          <Col span={8} style={{ color: "#888888" }}>
            Почта
          </Col>
          <Col span={16}>
            <Link to={`mailto:${rep.user?.userEmail}`}>
              {fallbackString(rep.user?.userEmail)}
            </Link>
          </Col>
        </>
        <>
          <Col span={8} style={{ color: "#888888" }}>
            Организация, выдавшая документ
          </Col>
          <Col span={16}>
            {fallbackString(rep.administrativeDocument?.organization)}
          </Col>
        </>
        <>
          <Col span={8} style={{ color: "#888888" }}>
            Документ, №, дата
          </Col>
          <Col span={16} style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
            {rep.administrativeDocument?.administrativeDocumentId &&
            rep.administrativeDocument?.documentUrl ? (
              <DocumentFileRow
                inline
                variant="link"
                downloadIconPosition="right"
                fileName={
                  formatAdministrativeDocument(rep.administrativeDocument) ||
                  rep.administrativeDocument.fileName ||
                  "document.pdf"
                }
                documentUrl={rep.administrativeDocument.documentUrl}
              />
            ) : (
              fallbackString(formatAdministrativeDocument(rep.administrativeDocument))
            )}
          </Col>
        </>
      </Row>
    );
  }
};


